<template>
  <div :class="classes" :style="styles">
    <slot></slot>
  </div>
</template>

<script>
import { PREFIX_CLASS } from '../../utils/constants'

const PREFIX_CLS = `${PREFIX_CLASS}carousel-item`
export default {
  name: 'TCarouselItem',
  inject: {
    parentVM: { default: null }
  },
  data() {
    return {
      height: this.parentVM.height,
      active: false
    }
  },
  computed: {
    classes() {
      return [
        PREFIX_CLS,
        {
          active: this.active
        }
      ]
    },
    left() {
      return this.parentVM.slides.indexOf(this) * -100 + '%'
    },
    top() {
      return this.parentVM.slides.indexOf(this) * -this.height + 'px'
    },
    styles() {
      let stylesObj = {}
      if (this.parentVM.effect === 'fade') {
        if (this.parentVM.vertical) {
          stylesObj = {
            top: `${this.top}`
          }
        } else {
          stylesObj = {
            left: `${this.left}`
          }
        }
      }
      return stylesObj
    }
  },
  mounted() {
    this.parentVM.addSlide(this)
  },
  methods: {
    toggleActive(active) {
      this.active = active
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/module/carousel/carousel-item.vue